module["exports"] = [
  "gmail.com",
  "yahoo.ca",
  "hotmail.com"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/fr_CA/internet/free_email.js
 ** module id = 602
 ** module chunks = 0
 **/